// Import global styles

import 'primeicons/primeicons.css';
import '@syncfusion/ej2-base/styles/material.css';
import '@syncfusion/ej2-buttons/styles/material.css';
import '@syncfusion/ej2-dropdowns/styles/material.css';
import '@syncfusion/ej2-inputs/styles/material.css';
import '@syncfusion/ej2-navigations/styles/material.css';
import '@syncfusion/ej2-popups/styles/material.css';
import '@syncfusion/ej2-splitbuttons/styles/material.css';
import '@syncfusion/ej2-grids/styles/material.css';
import '@syncfusion/ej2-vue-spreadsheet/styles/material.css';
import './style.css';
import './style-palette.css';

import { createApp } from 'vue';
import App from './App.vue';
import { setupPlugins } from './core/plugins';

const app = createApp(App);
setupPlugins(app);

app.mount('#app');
